<script lang="ts">
import FicheChecksRecu from '@/generated/fiches/FicheChecksRecu.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheChecksRecu
})

</script>
